// Current Card Designer output. Decorative image placeholders are not photo frames.
export function findPhotoFrame(cardDesign) {
  return cardDesign?.objectsFront?.find(object =>
    object.type === 'photo' && object.imagePlaceholder &&
    Number.isFinite(object.width) && object.width > 0 &&
    Number.isFinite(object.height) && object.height > 0
  ) || null;
}

export function getCropGeometry(width, height, aspect, naturalWidth, naturalHeight) {
  if (![width, height, aspect, naturalWidth, naturalHeight].every(v => Number.isFinite(v) && v > 0)) return null;
  const frameW = Math.min(width * 0.8, height * 0.8 * aspect);
  const frameH = frameW / aspect;
  const frameX = (width - frameW) / 2;
  const frameY = (height - frameH) / 2;
  const displayScale = Math.max(frameW / naturalWidth, frameH / naturalHeight);
  // Floor the source margin so rounding cannot expose a blank edge.
  const maxX = Math.max(0, Math.floor(naturalWidth - frameW / displayScale + 1e-7));
  const maxY = Math.max(0, Math.floor(naturalHeight - frameH / displayScale + 1e-7));
  const centeredX = frameX + (frameW - naturalWidth * displayScale) / 2;
  const centeredY = frameY + (frameH - naturalHeight * displayScale) / 2;
  return {
    frameX, frameY, frameW, frameH, displayScale, maxX, maxY, centeredX, centeredY,
    centerCrop: {
      x: Math.min(maxX, Math.max(0, Math.round((frameX - centeredX) / displayScale))),
      y: Math.min(maxY, Math.max(0, Math.round((frameY - centeredY) / displayScale))),
      scale: 1
    }
  };
}

export function clampSourceCrop(crop, geometry) {
  return {
    x: Math.min(geometry.maxX, Math.max(0, Math.round(crop.x))),
    y: Math.min(geometry.maxY, Math.max(0, Math.round(crop.y))),
    scale: 1
  };
}
